export enum ProductCodes {
  OnlinePurchaseAllowed = "40332",
}
